import * as React from 'react'
import { SVGProps } from 'react'
const IllustrationClaims = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox='0 0 621 428'
    {...props}
    aria-hidden='true'
  >
    <defs>
      <linearGradient
        id='a'
        x1='50.019%'
        x2='50.019%'
        y1='99.988%'
        y2='-.007%'
      >
        <stop
          offset='0%'
          stopColor='gray'
          stopOpacity={0.25}
        />

        <stop
          offset='54%'
          stopColor='gray'
          stopOpacity={0.12}
        />

        <stop
          offset='100%'
          stopColor='gray'
          stopOpacity={0.1}
        />
      </linearGradient>
    </defs>

    <g
      fill='none'
      fillRule='nonzero'
      transform='translate(-13 -28)'
    >
      <path
        fill='transparent'
        d='M204.746 49.613c21.068-18.965 54.143-22.827 84.246-21.318 94.555 4.743 179.91 50.806 253.74 102.912 26.728 18.864 53.042 39.21 70.407 65.168 35.322 52.88 24.842 126.137-24.266 169.697-16.71 14.825-36.967 26.185-57.76 36.261-36.973 17.908-76.857 32.28-118.828 36.374-29.925 2.916-60.195.537-89.97-3.524-83.118-11.376-164.705-36.524-233.09-79.568-30.007-18.875-58.278-42.341-70.64-72.893-12.36-30.55-4.45-69.229 26.175-87.303 12.668-7.476 27.808-10.85 42.637-14.024 21.826-4.662 43.996-9.265 63.694-18.75 20.343-9.798 44.426-28.747 40.4-50.436-4.32-23.252-7.787-43.689 13.255-62.596z'
        opacity={0.1}
      />

      <path
        fill='currentColor'
        d='M151 269.225s5.898-3.812 12-1.457c0 0-1.706 3.273-9.31 3.232l-2.69-1.775zM149.217 268s-1.383 7.277 2.833 12c0 0 2.337-3.08-.32-10.246L149.217 268zM143 262.043s.204-5.092 12.999-3.847c0 0 .199 3.275-4.199 4.981-4.397 1.705-6.505.48-8.8-1.134zm-1.75.957s-5.025 1.98-.056 14c0 0 3.324-.951 3.745-5.829.422-4.877-1.417-6.488-3.689-8.171zm-7.228-8.954s-1.074-8.444 11.935-8.031c0 0 1.24 7.633-9.558 9.985l-2.377-1.954zM125 244.753s1.332-9.8 13.999-7.364c0 0 .383 8.42-11.842 9.611L125 244.753zm-6-10.603s2.493-10.314 15-7.737c0 0-2.586 9.277-14.105 9.587l-.895-1.85zm-7-10.899s2.502-10.48 15-7.818c0 0-3.75 9.993-14.127 9.553L112 223.25zm-4-9.134s1.69-13.278 13-10.811c0 0-2.818 12.132-12.116 12.694l-.884-1.883zm-5-11.914s2.179-12.966 14-9.665c0 0-4.112 12.332-13.117 11.413l-.883-1.748zm-3-11.661s3.804-12.547 13-12.542c0 0-3.886 13.23-12.13 15l-.87-2.458zm-1-10.059s4.232-16.405 12-15.442c0 0-2.883 12.522-11.629 17.959L99 180.483zm-1-13.986s4.159-13.668 12-14.497c0 0-2.668 13.398-11.687 18L98 166.497zm-1-12.505s5.066-12.538 10-12.992c0 0-1.915 12.235-9.42 15l-.58-2.008zm-2-11.052s2.959-14.56 8-15.94c0 0-.222 11.824-7.448 17L95 142.94zm-2-13.813s2.675-12.138 6-14.127c0 0-.224 14.167-5.136 17L93 129.127zm-1.6-10.564L90 99s7.431 14.515 2.036 23l-.636-3.437zm-7.398-18.901S78.274 84.791 77 84c0 0 10.511 9.402 9.98 22l-2.978-6.338zm48.951 155.349s-8.636-.84-7.91 11.963c0 0 7.81 1.02 9.957-9.68l-2.047-2.283zM123.721 245s-11.017.379-9.594 13.964c0 0 9.31 1.284 11.873-11.477L123.721 245zm-4.673-10.304S108.91 230.575 103 242.39c0 0 9.347 3.398 17-5.849l-.952-1.845z'
      />

      <path
        fill='currentColor'
        d='M113.078 223.871s-10.484-4.65-16.078 7.538c0 0 10.87 3.297 17-5.684l-.922-1.854zm-5.604-9.203s-10.078-8.741-17.474.764c0 0 10.225 7.118 18 1.247l-.526-2.01zm-3.904-13.097S93.364 192.88 86 202.616c0 0 11.347 7.026 18 .83l-.43-1.875zm-1.592-11.428S93.886 178.491 85 181.495c0 0 8.408 12.348 17 11.46l-.022-2.812zm-3.253-10.531S90.83 165.616 84 168.355c0 0 5.708 10.77 15 13.645l-.275-2.388zm-.537-13.914S90.635 154.493 84 156.17c0 0 6.254 11.42 15 12.829l-.812-3.302zM98 154.786S91.149 141.93 86 142c0 0 3.56 12.89 11.662 15l.338-2.214zm-2-11.96s-7.065-12.988-12-12.824c0 0 3.79 11.194 11.823 13.998l.177-1.174zm-2-14.6S88.92 118.024 85 117c0 0 2.823 12.559 8.587 14l.413-2.774z'
      />

      <path
        fill='currentColor'
        d='M90.32 117.942 79 102s3.356 16.036 13 19l-1.68-3.058zm-8.781-18.08S68.533 91.428 68 90c0 0 6.927 12.262 19 14l-5.461-4.138zM80.652 97S65.684 83.845 62 84.001c0 0 11.928.084 19 12.26l-.348.739z'
      />

      <path
        fill='#444053'
        d='m94 130.909-.527.091C89.953 109.532 85.521 96.94 81 95.536l.153-.536c4.785 1.48 9.243 13.889 12.847 35.909zm6 51.995-.715.096c-.22-2-.41-4.055-.558-6.098-1.293-17.786-2.915-34.101-4.727-46.308l.396-.594c1.817 12.228 3.753 29.025 5.05 46.838.149 2.032.335 4.07.554 6.066z'
      />

      <path
        fill='#444053'
        d='M165.619 278c-.145-.06-14.613-5.871-29.96-20.471a117.432 117.432 0 0 1-22.454-29.383C105.848 214.497 101.034 197.556 99 181l.859.365c4.561 37.16 22.496 61.999 36.491 75.347 15.198 14.471 29.516 20.224 29.65 20.278l-.381 1.01z'
      />

      <g opacity={0.7}>
        <path
          fill='currentColor'
          d='M173.332 234.709s6.539-2.153 11.34 1.922c0 0-2.576 2.799-9.456.613l-1.884-2.535zm-.735.011s-3.423 5.958-.372 11.454c0 0 3.24-1.954 2.489-9.107l-2.117-2.347zm-5.254-8.015s1.89-5.34 13.743-.21c0 0-.891 3.536-5.68 4.032-4.79.495-6.389-1.438-8.063-3.822zm-.751-.242s-5.67.269-4.147 13.063c0 0 3.656.162 5.508-4.268 1.852-4.43.454-6.513-1.36-8.795zm-4.892-9.63s1.723-9.15 14.089-4.845c0 0-1.302 8.36-12.447 7.6l-1.642-2.755zm-5.594-12.38s4.482-9.69 16.275-3.273c0 0-2.333 8.8-14.877 6.255l-1.398-2.982zm-3.262-12.085s5.589-9.15 17.28-2.793c0 0-5.4 8.106-16.94 4.844l-.34-2.05zm-3.019-11.782s5.616-9.517 16.843-3.182c0 0-6.669 8.677-16.519 5.146l-.324-1.964zm-1.101-10.717s5.583-11.982 16.081-6.169c0 0-6.367 10.55-15.746 8.22l-.335-2.051zm-.314-12.677s6.043-11.965 16.417-5.215c0 0-7.706 10.765-16.098 7.18l-.318-1.965zm.794-11.502s7.56-11.552 16.287-8.839c0 0-7.868 12.235-16.243 11.578l-.044-2.74zm1.534-11.03s8.64-14.032 15.493-10.927c0 0-6.286 10.814-15.882 13.371l.389-2.444zm2.641-12.934s7.678-11.568 14.882-10.174c0 0-6.264 11.73-15.617 13.516l.735-3.342zm2.359-12.085s8.721-11.303 13.473-10.324c0 0-5.686 11.907-13.575 12.537l.102-2.213zm2.403-11.191s6.988-12.918 11.967-12.832c0 0-3.705 11.126-11.778 13.995l-.189-1.162zm2.155-14.915s6.399-10.087 10.633-10.765c0 0-4.266 12.778-10.487 13.677l-.146-2.912zm1.112-9.882 4.574-19.604s3.084 16.552-4.984 23.145l.41-3.541zm-.226-20.761s-1.248-15.546-2.252-16.687c0 0 7.484 11.885 3.305 23.458l-1.053-6.771zm.188 163.796s-8.64-3.575-11.777 9.107c0 0 7.728 3.488 13.192-6.228l-1.414-2.88zm-5.6-12.666s-10.33-2.815-12.986 10.313c0 0 8.262 3.887 14.375-7.326l-1.388-2.987zm-3.25-10.846s-8.197-6.917-17.28 2.793c0 0 7.679 5.991 17.61-.742l-.33-2.051zm-2.927-12.553s-8.348-7.256-16.988 2.288c0 0 9.083 6.136 17.307-.323l-.319-1.965z'
        />

        <path
          fill='currentColor'
          d='M148.778 170.176s-6.869-11.304-16.665-4.382c0 0 7.49 9.797 16.557 6.46l.108-2.078zm.237-13.146s-6.868-11.513-16.74-4.063c0 0 8.446 10.227 16.562 6.045l.178-1.981zm1.232-11.448s-4.12-13.172-13.241-12.919c0 0 4.212 13.92 12.447 15.567l.794-2.648zm.696-10.932s-3.391-16.122-10.88-15.497c0 0 2.256 12.294 10.421 17.93l.46-2.433zm3.132-13.516s-4.406-13.156-11.734-13.667c0 0 3.008 12.945 11.578 17.09l.156-3.423zm2.517-11.53s-2.366-14.06-7.02-15.432c0 0-.6 13.171 6.058 17.434l.962-2.002zm1.852-11.364s-2.965-14.398-7.765-15.717c0 0 .34 11.719 7.252 16.773l.513-1.055zm2.667-13.65s-1.944-11.777-5.583-14.032c0 0-1.08 13.424 4.32 16.686l1.263-2.654z'
        />

        <path
          fill='currentColor'
          d='m160.939 73.114-6.297-19.119s-1.62 16.762 7.02 22.634l-.723-3.515zm-2.565-19.577s-10.115-11.9-10.19-13.403c0 0 3.094 13.689 14.24 18.958l-4.05-5.555zm.296-4.042s-10.567-17.52-14.212-18.49c0 0 11.62 3.71 14.753 17.85l-.54.64z'
        />

        <path
          fill='#444053'
          d='m160.42 86.571-.54-.075c2.986-21.644 2.43-35.069-1.577-37.787l.308-.447c4.25 2.89 4.871 16.138 1.81 38.31z'
        />

        <path
          fill='#444053'
          d='m150.808 137.707-.804-.145c.367-1.997.777-4.032 1.23-6.05 3.948-17.521 7.096-33.734 8.797-46.071l.61-.442c-1.706 12.38-4.66 29.148-8.607 46.695-.454 1.976-.864 4-1.226 6.013z'
        />

        <path
          fill='#444053'
          d='M185.298 248.618c-.119-.097-12.28-9.974-22.68-28.529a117.357 117.357 0 0 1-12.776-34.81c-2.987-15.254-2.55-32.899.453-49.343l.713.603c-6.723 36.915 3.078 66.035 12.55 82.985 10.26 18.377 22.29 28.152 22.415 28.249l-.675.845z'
        />
      </g>

      <path
        fill='currentColor'
        d='M557.562 433.028s-23.06-1.32-20.339 14.03c0 0-.545 2.709 2.046 3.942 0 0 .043-1.14 2.367-.751.826.132 1.667.17 2.503.114a5.396 5.396 0 0 0 3.065-1.202s6.48-2.544 9-12.605c0 0 1.865-2.196 1.794-2.76l-3.894 1.553s1.33 2.668.283 4.88c0 0-.125-4.781-.872-4.662-.153.026-2.024.927-2.024.927s2.291 4.663.546 8.02c0 0 .654-5.725-1.277-7.688l-2.727 1.523s2.673 4.797.862 8.709c0 0 .464-6.005-1.44-8.341l-2.481 1.839s2.514 4.73.981 7.973c0 0-.201-6.989-1.516-7.517 0 0-2.182 1.818-2.503 2.59 0 0 1.718 3.43.654 5.243 0 0-.654-4.663-1.194-4.663 0 0-2.182 3.083-2.39 5.18 0 0 .093-3.144 1.866-5.49a6.609 6.609 0 0 0-3.31 1.626s.338-2.18 3.817-2.373c0 0 1.79-2.336 2.27-2.481 0 0-3.497-.275-5.613.616 0 0 1.865-2.072 6.25-1.124l2.45-1.901s-4.599-.596-6.546.062c0 0 2.242-1.818 7.205-.492l2.667-1.513s-3.916-.803-6.25-.518c0 0 2.465-1.264 7.036.104l1.909-.814s-2.875-.518-3.715-.621c-.84-.104-.883-.306-.883-.306a10.424 10.424 0 0 1 5.388.57s4.086-1.435 4.015-1.679z'
      />

      <ellipse
        cx={542}
        cy={453.5}
        fill='currentColor'
        opacity={0.1}
        rx={16}
        ry={2.5}
      />

      <path
        fill='currentColor'
        d='M601.739 392.016s-13.174-.73-11.61 7.794c-.165.886.305 1.77 1.167 2.19 0 0 .027-.633 1.354-.419.473.076.953.099 1.432.067a3.09 3.09 0 0 0 1.747-.669s3.704-1.414 5.147-7.003c0 0 1.067-1.22 1.023-1.532l-2.212.878s.758 1.48.16 2.71c0 0-.071-2.659-.497-2.592-.088 0-1.155.51-1.155.51s1.304 2.583.32 4.456c0 0 .376-3.18-.73-4.267l-1.564.842s1.526 2.665.492 4.84c0 0 .265-3.334-.824-4.636l-1.415 1.021s1.432 2.63.553 4.431c0 0-.116-3.88-.868-4.175a8.465 8.465 0 0 0-1.432 1.424s.984 1.909.376 2.914c0 0-.376-2.588-.68-2.598 0 0-1.238 1.715-1.366 2.89a5.913 5.913 0 0 1 1.067-3.063 3.842 3.842 0 0 0-1.896.903s.194-1.21 2.211-1.317c0 0 1.023-1.301 1.294-1.378 0 0-1.996-.153-3.206.342 0 0 1.067-1.143 3.571-.628l1.404-1.051s-2.631-.332-3.743.035c0 0 1.283-1.02 4.12-.275l1.525-.843a15.067 15.067 0 0 0-3.577-.285s1.41-.7 4.02.06l1.105-.453s-1.659-.296-2.123-.342c-.464-.046-.509-.174-.509-.174a6.146 6.146 0 0 1 3.085.317s2.273-.787 2.234-.924z'
      />

      <ellipse
        cx={593}
        cy={401.5}
        fill='currentColor'
        opacity={0.1}
        rx={9}
        ry={1.5}
      />

      <path
        fill='currentColor'
        d='M525.71 399.02s-15.377-.956-13.56 10.132c-.194 1.153.356 2.303 1.362 2.848 0 0 0-.82 1.576-.55a7.133 7.133 0 0 0 1.672.088 3.465 3.465 0 0 0 2.041-.868s4.323-1.836 6.006-9.11c0 0 1.245-1.583 1.191-1.99l-2.591 1.138s.887 1.93.187 3.53c0 0-.08-3.458-.582-3.376-.102 0-1.347.666-1.347.666s1.523 3.358.374 5.794c0 0 .438-4.134-.85-5.553l-1.827 1.1s1.78 3.463.572 6.294c0 0 .31-4.337-.956-6.047l-1.657 1.325s1.678 3.414.657 5.761c0 0-.133-5.046-1.015-5.431 0 0-1.448 1.314-1.667 1.853 0 0 1.144 2.479.433 3.787 0 0-.433-3.359-.79-3.375 0 0-1.443 2.226-1.604 3.755a8.282 8.282 0 0 1 1.245-3.97 4.304 4.304 0 0 0-2.206 1.177s.224-1.578 2.564-1.715c0 0 1.192-1.688 1.512-1.792 0 0-2.33-.198-3.74.445 0 0 1.24-1.49 4.162-.814l1.635-1.369s-3.061-.434-4.365.044c0 0 1.496-1.313 4.809-.357l1.78-1.1s-2.614-.582-4.174-.373c0 0 1.646-.907 4.691.077l1.277-.539s-1.912-.385-2.473-.445c-.562-.06-.588-.22-.588-.22a6.469 6.469 0 0 1 3.596.412s2.698-1.055 2.65-1.231z'
      />

      <ellipse
        cx={515}
        cy={413}
        fill='currentColor'
        opacity={0.1}
        rx={11}
        ry={2}
      />

      <path
        fill='#000'
        d='m397 404.779-54.073 20.82L263.89 456c-2.98-5.51-7.38-13.047-12.824-21.995-18.716-30.873-49.69-78.891-77.257-121.09A13564.797 13564.797 0 0 0 116 225.222l19.358-5.584L293.474 174 397 404.779z'
        opacity={0.1}
      />

      <path
        fill='#FFF'
        d='m398 400.779-54.073 20.82L264.89 452c-2.98-5.51-7.38-13.047-12.824-21.995-18.716-30.873-49.69-78.891-77.257-121.09A13564.797 13564.797 0 0 0 117 221.222l19.358-5.584L294.474 170 398 400.779z'
      />

      <path
        fill='#000'
        d='m398 400.688-54.147 20.811a409.83 409.83 0 0 1-91.986 8.403c-18.742-30.86-49.758-78.86-77.363-121.041L136 215.618 294.332 170 398 400.688z'
        opacity={0.1}
      />

      <path
        fill='currentColor'
        d='M438 388.028s-83.893 49.5-209.14 38.33L129 183.538l47.852-8.2L342.269 147l93.858 236.335 1.873 4.693z'
      />

      <path
        fill='#000'
        d='M436 383.441c-19.737.967-42.562.876-65.537-1.859-24.857-2.912-49.832-8.94-71.29-19.974-17.92-9.224-33.242-19.244-46.606-31.272-34.748-31.224-56.255-75.89-75.567-154.986L342.256 147 436 383.441z'
        opacity={0.1}
      />

      <path
        fill='#FFF'
        d='M497 368.944s-61.676 12.071-124.393 4.636c-24.805-2.92-49.756-8.919-71.143-19.929-17.882-9.203-33.172-19.2-46.509-31.201-42.934-38.593-65.588-97.673-88.955-217.039 0 0 102.507 24.705 203.784-29.411 0 0 34.16 212.943 127.216 292.944z'
      />

      <path
        fill='#000'
        d='M372 375c-24.668-2.959-49.48-9.034-70.749-20.185-17.783-9.321-32.988-19.446-46.251-31.601C291.34 320.212 296.565 300 296.565 300 323.507 343.496 372 375 372 375z'
        opacity={0.1}
      />

      <path
        fill='currentColor'
        d='M218 148.722s55.497 6.297 107.44-22.722l3.56 11.364S279.307 162 218 162v-13.278z'
        opacity={0.3}
      />

      <path
        fill='#000'
        d='M218 204.61s55.326-4.384 116.917-33.61l2.083 4.676S314.333 203.683 218 211v-6.39zm6 21.967s55.326-4.38 116.917-33.577l2.083 4.672S320.338 225.683 224 233v-6.423zm6 23s55.326-4.38 116.917-33.577l2.083 4.672S326.305 248.667 230 256v-6.423zm8 20.996s55.326-4.38 116.917-33.573l2.083 4.671S334.338 269.668 238 277v-6.427z'
        opacity={0.3}
      />

      <path
        fill='#000'
        d='M245 292.577s55.326-4.38 116.917-33.577l2.083 4.672s-22.667 28-119 35.328v-6.423z'
        opacity={0.1}
      />

      <path
        fill='currentColor'
        d='m343.59 161.916 15.349-5.218 5.225 15.33-15.348 5.218zm8.732 22.806 15.348-5.218 5.225 15.33-15.348 5.218zm13.998 43.881 15.348-5.218 5.224 15.33-15.348 5.218zm8.03 23.552 15.349-5.219 5.225 15.33-15.348 5.218zm-14.909-43.741 15.348-5.219 5.225 15.33-15.348 5.218z'
        opacity={0.09}
      />

      <path
        fill='url(#a)'
        d='m535.69 269.505-.575-.537c1.485-.3 2.885-.435 2.885-.435s-5.098-18.385-13.694-24.519c-4.253-3.032-7.794-8.081-10.297-12.412a187.637 187.637 0 0 0-15.336-22.415l-1.55-1.948-.668-.848c.931-1.406 2.072-2.743 1.943-4.374a2.054 2.054 0 0 0 0-.29 2.992 2.992 0 0 0-.107-.595l-.06.09c-.726-2.103-3.52-3.031-5.592-4.19-4.845-2.721-6.917-8.667-7.951-14.194-.807-4.293-1.475-9.123-4.845-11.887-2.153-1.776-5.081-2.361-7.25-4.127-2.057-1.674-3.203-4.212-4.495-6.547-2.153-3.89-4.995-7.513-8.747-9.836-3.752-2.324-8.516-3.22-12.634-1.664-1.577.601-3.009 1.535-4.57 2.184-3.876 1.61-8.316 1.396-12.154 3.097-4.727 2.093-7.8 6.718-10.61 11.108-1.453 2.27-3.736 5.592-5.033 8.935v-.349a12.75 12.75 0 0 0-1.001 4.648c-.026.68.049 1.36.22 2.017.582 2.147 2.315 3.333 4.371 4.16.12.682.278 1.358.474 2.022a19.884 19.884 0 0 0 12.865 13.1c.178.064.36.107.538.16.15.426.366.824.64 1.181 1.718 2.147 5.163 1.535 7.402-.026.092-.06.178-.135.264-.199.015.304.048.607.097.907.048.258.086.537.14.767 2.019 10.846 7.186 16.7 7.186 16.7s.48.72 1.26 1.911c-.41 5.983 2.33 11.436 5.496 15.648-2.73 1.573-8.613 4.653-12.252 4.395 0 0-13.37 1.723-14.921.859-.215-.118-.42.043-.614.408-3.682-2.238-15.454-8.688-16.46-.408-.91 7.513 9.818 8.474 14.926 8.511-.231 2.2-.36 3.96-.36 3.96l21.967-1.497 11.439-1.68c-1.265 1.67-2.692 3.156-4.086 3.88 0 0-10.34 8.345-12.128 8.42-.253 0-.333.253-.296.655-4.349 0-17.876.628-14.124 8.14 3.407 6.81 13 2.1 17.338-.504a126.021 126.021 0 0 0 1.895 3.532l17.725-12.585 3.838-3.22a13.693 13.693 0 0 0 3.817-.735c0 .049.038.097.054.14.137.395.24.8.307 1.213 1.076 6.166-2.541 20.548-2.541 20.548s-7.956 20.225-4.134 22.984c3.822 2.758.996 14.398.996 14.398a21.522 21.522 0 0 0 2.293 3.155c.404.466.853.892 1.34 1.272a12.21 12.21 0 0 0-.441 1.476c-.584 2.48-.364 5.08.63 7.427 2.626 6.354 1.028 15.562 1.028 15.562l-5.157 34.732c-2.476-.376-5.674-.687-6.863 0-1.825 1.025-1.228 6.192 3.009 8.414a10.921 10.921 0 0 1-4.36 2.002c-3.768.858-6.417 1.406-8.16 1.739-.114 0-9.044-1.965-11.337-.666-2.293 1.299-1.19 8.5 5.334 10.266 6.384 1.723 30.193 4.25 37.05 3.22l.437-.075c5.83-1.149.71-8.785.064-9.713-.043-.312-.08-.64-.124-.993a50.4 50.4 0 0 1-.231-2.683c6.502.595 12.919.885 15.863.445.14 0 .27-.043.388-.07 5.162-1.02.64-7.77.059-8.586l-.08-.66v-.06c0-.155-.038-.321-.055-.482-.016-.161 0-.274-.043-.419-.043-.145 0-.257-.037-.391-.022-.265-.043-.539-.065-.821v-.35c0-.214-.027-.429-.038-.649v-.36c0-.321 0-.654-.032-.987v-2.624c0-.36.032-.73.054-1.1l.032-.397c0-.274.043-.537.07-.816 0-.134 0-.268.043-.402.043-.376.092-.751.146-1.132 0-.113.037-.226.053-.339.049-.284.097-.574.151-.864 0-.139.054-.284.086-.429.065-.311.135-.622.21-.934 0-.085.038-.171.06-.257a26.409 26.409 0 0 1 .44-1.503c.092-.279.19-.536.292-.826l.129-.344c.145-.365.301-.724.463-1.073.043-.091.091-.182.14-.274.134-.279.28-.536.43-.826l.183-.317c.205-.343.415-.687.646-1.014 5.921-8.414 7.482-24.642 7.337-28.173-.145-3.531.705-10.857 1.766-11.94.71-.725 4.844-6.44 7.315-10.787a31.29 31.29 0 0 0 1.141-2.206c1.755-.606 2.918-1.073 2.918-1.073a24.812 24.812 0 0 1-.883-6.917c.043-4.567 1.303-10.583 6.502-15.466 7.676-7.213 8.748-14.36 8.85-17.108v-.51a10.986 10.986 0 0 0-.043-.751z'
      />

      <path
        fill='#FBBFBF'
        d='M515.279 313.364a92.923 92.923 0 0 1-6.93 10.727c-1.002 1.08-1.806 8.374-1.668 11.878.139 3.504-1.327 19.657-6.93 28.025-5.601 8.368-2.723 22.832-2.723 22.832L488.09 390h-10.74l-7.398-2.24-1.951-5.453s2.601-.405 9.061-1.96c3.683-.76 6.416-3.908 6.69-7.704l4.536-32.085s1.338-8.098-.87-13.702a11.28 11.28 0 0 1 .726-9.772l.144-.227s6.998-5.599 14.13-9.102c6.316-3.089 12.723-4.557 14.54.923.235.707-.532 2.526-1.678 4.686z'
      />

      <path
        fill='#000'
        d='M515.279 313.366a92.942 92.942 0 0 1-6.93 10.729c-1.002 1.08-1.806 8.375-1.668 11.88.139 3.504-1.327 19.66-6.93 28.03-3.943 5.902-3.682 14.823-3.197 19.58.208 1.993.464 3.24.464 3.24l-8.94 3.175H477.35l-7.398-2.225-1.951-5.454s.65-.102 2.132-.394c1.482-.291 3.731-.788 6.961-1.566 3.67-.772 6.388-3.918 6.658-7.705l4.536-32.091s1.338-8.1-.87-13.705a11.285 11.285 0 0 1 .726-9.774l.144-.227s6.998-5.6 14.13-9.104c6.316-3.089 12.723-4.557 14.54.923.235.708-.532 2.528-1.678 4.688z'
        opacity={0.05}
      />

      <path
        fill='#000'
        d='M496 386.862 486.762 390h-11.1l-7.646-2.22-2.016-5.39s.672-.102 2.203-.39c-.223 2.027 1.15 3.897 3.201 4.355l4.34.144c.612 0 1.23.032 1.835.032a56.968 56.968 0 0 0 17.947-2.887c.22 1.97.474 3.218.474 3.218z'
        opacity={0.1}
      />

      <path
        fill='#444'
        d='m476.997 387.743-4.301-.152s-4.013-.876-3.031-5.57c0 0-7.742-1.809-9.721-.612s-1.025 7.8 4.569 9.42c5.452 1.579 25.874 3.9 31.746 2.95l.376-.068c5.321-1.124 0-8.992 0-8.992a53.489 53.489 0 0 1-19.638 3.024z'
      />

      <path
        fill='#FBBFBF'
        d='M502.781 315.908a39.116 39.116 0 0 1-.927 1.77c-2.624 4.811-6.834 10.869-7.57 11.654-1.124 1.209-2.02 9.357-1.877 13.292.143 3.934-1.49 21.962-7.777 31.319-3.218 4.811-3.944 11.36-3.891 16.632.016 1.786.12 3.57.312 5.346.234 2.176.53 3.534.53 3.534L471.552 403h-12.07l-8.307-2.491-2.174-6.117s.726-.117 2.36-.443c1.632-.327 4.176-.872 7.813-1.738 4.123-.86 7.18-4.373 7.49-8.608l5.085-35.858s1.5-9.062-.97-15.317a12.394 12.394 0 0 1-.594-7.32c.295-1.372.834-2.68 1.59-3.86 0 0 1.94-1.539 4.867-3.576a108.228 108.228 0 0 1 4.405-2.898c7.083-4.421 16.397-8.933 20.86-5.645a5.823 5.823 0 0 1 2.058 2.988c.18.62-.324 2.026-1.183 3.79z'
      />

      <path
        fill='#000'
        d='M482 399.475 471.525 403h-12.58l-8.675-2.477-2.27-6.082s.759-.117 2.464-.441c-.221 1.463.33 2.936 1.472 3.929a5.054 5.054 0 0 0 3.123 1.127l3.97.122c.692 0 1.39.037 2.082.037a65.351 65.351 0 0 0 20.363-3.253c.244 2.163.526 3.513.526 3.513z'
        opacity={0.1}
      />

      <path
        fill='#444'
        d='m458.255 400.26-3.89-.129a4.93 4.93 0 0 1-3.07-1.137c-.99-.868-1.842-2.37-1.288-4.895 0 0-8.694-1.946-10.938-.66-2.245 1.288-1.147 8.402 5.14 10.145 6.156 1.7 29.109 4.198 35.716 3.18l.418-.076c5.978-1.211 0-9.693 0-9.693a62.414 62.414 0 0 1-22.088 3.265z'
      />

      <path
        fill='#000'
        d='M515.263 315.22c-3.653 1.269-9.018 2.953-11.961 3.022a5.386 5.386 0 0 1-.912-.043c-2.059-.281-8.42.17-14.255.69-2.341.208-4.592.426-6.453.617-2.773.287-4.682.494-4.682.494v-1.8a109.01 109.01 0 0 1 4.432-2.88c7.124-4.393 16.494-8.877 20.984-5.61 6.32-3.038 12.73-4.483 14.548.909.214.685-.554 2.475-1.7 4.6z'
        opacity={0.1}
      />

      <path
        fill='currentColor'
        d='M531.996 271.899c-.104 2.767-1.138 9.948-8.552 17.206-9.45 9.25-5.444 22.532-5.444 22.532s-11.268 4.437-16.13 4.557a5.463 5.463 0 0 1-.93-.044c-2.918-.41-14.503.666-21.16 1.342-2.831.295-4.78.508-4.78.508v-39.29L527.222 266l4.73 4.72c.041.392.056.786.044 1.179z'
      />

      <path
        fill='#000'
        d='M531.996 271.899c-.104 2.767-1.138 9.948-8.552 17.206-9.45 9.25-5.444 22.532-5.444 22.532s-11.268 4.437-16.13 4.557a5.463 5.463 0 0 1-.93-.044c-2.918-.41-14.503.666-21.16 1.342-2.831.295-4.78.508-4.78.508v-39.29L527.222 266l4.73 4.72c.041.392.056.786.044 1.179z'
        opacity={0.25}
      />

      <path
        fill='#000'
        d='m476.178 317.014-.85.09v.408s1.925-.209 4.721-.498c4.722-.478 11.933-1.148 16.702-1.346-3.301-.3-14.207.702-20.573 1.346zm55.408-45.948-4.673-4.642-3.113.777 3.914 3.886c.027.388.027.776 0 1.164-.102 2.712-1.124 9.773-8.448 16.902-9.335 9.082-5.377 22.135-5.377 22.135s-9.211 3.603-14.487 4.348c.503-.002 1.006.025 1.506.08.305.043.612.059.92.049 4.802-.118 15.933-4.477 15.933-4.477s-3.98-13.053 5.377-22.135c7.324-7.13 8.346-14.19 8.448-16.902.027-.395.027-.79 0-1.185z'
        opacity={0.1}
      />

      <path
        fill='#FBBFBF'
        d='M429 245.355s-15.787-11.263-16.947-1.12c-1.16 10.143 16.947 8.693 16.947 8.693v-7.573z'
      />

      <path
        fill='currentColor'
        d='M456.633 238s-8.41 5.442-13.061 5.107c0 0-12.713 1.667-14.192.834C427.9 243.107 427 256 427 256l20.902-1.442 13.399-2.003s6.699-3.995 6.699-7.44c0-3.445-11.367-7.115-11.367-7.115z'
      />

      <path
        fill='#000'
        d='M456.633 238s-8.41 5.442-13.061 5.107c0 0-12.713 1.667-14.192.834C427.9 243.107 427 256 427 256l20.902-1.442 13.399-2.003s6.699-3.995 6.699-7.44c0-3.445-11.367-7.115-11.367-7.115z'
        opacity={0.05}
      />

      <path
        fill='#FBBFBF'
        d='M444.145 265.018s-18.727-.813-14.533 8.359c4.195 9.171 18.388-1.962 18.388-1.962l-3.855-6.397z'
      />

      <path
        fill='currentColor'
        d='M463 248s-14.897-11.577-12.797-25.676c2.1-14.099 12.797 10.792 12.797 10.792V248z'
      />

      <path
        fill='#FBBFBF'
        d='M459 182.495a19.529 19.529 0 0 1-5.487 13.552 18.345 18.345 0 0 1-2.816 2.402 20.116 20.116 0 0 1-6.4 2.957c-.91.227-1.834.392-2.767.491-.669.065-1.343.103-2.029.103a19.027 19.027 0 0 1-6.425-1.08c-9.373-3.272-14.792-13.066-12.586-22.748 2.206-9.682 11.332-16.16 21.197-15.048 9.865 1.113 17.319 9.463 17.313 19.393v-.022z'
      />

      <path
        fill='#000'
        d='M531.978 272.787c-1.748.32-3.905.9-3.905 1.798 0 1.515-24.362 9.679-24.362 9.679s.911 2.109-1.52 5.738c-2.433 3.63-22.234 24.486-22.234 24.486l.065.62.253 2.404L481.483 329s-7.614-2.72-10.051-2.42c-.787.102-1.618-.401-2.432-1.124.3-1.374.849-2.684 1.618-3.865 0 0 1.973-1.541 4.95-3.581v-38.543L527.297 267l4.686 4.63a8.59 8.59 0 0 1-.005 1.157z'
        opacity={0.1}
      />

      <path
        fill='currentColor'
        d='M535 269.644s-6.12.598-6.12 2.108c0 1.51-24.467 9.65-24.467 9.65s.915 2.102-1.528 5.72c-2.442 3.618-22.328 24.416-22.328 24.416L482.09 326s-7.647-2.711-10.095-2.412c-1.083.133-2.302-.86-3.304-2.017a20.994 20.994 0 0 1-2.204-3.101s2.757-11.458-.915-14.17c-3.672-2.71 3.975-22.6 3.975-22.6s3.455-14.142 2.437-20.21a7.191 7.191 0 0 0-.292-1.196c0-.042-.027-.09-.044-.133-2.166-5.796-25.648-54.435-25.648-54.435.015-1.38.112-2.757.292-4.125.05-.379.114-.774.185-1.174.119-.72.278-1.432.476-2.135.124-.45.273-.893.444-1.328.726-1.836 1.836-3.25 3.493-3.282 0 0 1.836-2.002 6.142-2.546 3.151-.406 7.652 0 13.744 2.546 14.368 6.02 17.736 6.329 17.736 6.329l7.22 9.34 1.483 1.915a184.37 184.37 0 0 1 14.736 22.04c2.405 4.27 5.811 9.228 9.895 12.211 8.258 6.047 13.154 24.127 13.154 24.127z'
      />

      <path
        fill='#000'
        d='M482 234s20.18 5.112 28 18l-28-18zm6 23s3.89 25.956 2.81 27.908C489.73 286.86 488 257 488 257zm-1.484 13.508c-1.474 1.93-7.462 16.855-7.462 16.855l1.727 25.062L482.304 327s-7.59-2.732-10.022-2.43c-1.076.134-2.292-.867-3.282-2.034 1.576-8.535 4.95-26.396 5.557-26.74.802-.457 4.906-14.806 5.121-18.824.216-4.017 5.918-12.972 5.918-12.972s2.405 4.577.92 6.508zm-5.61-25.543c-.383 1.132-.973 7.723-.973 7.723-.427 5.802-4.924 7.7-7.686 8.312a7.195 7.195 0 0 0-.296-1.201C470.097 254.656 446 204.986 446 204.986c.025-2.52.348-5.028.963-7.475 5.246-1.512 13.55.815 13.55.815 2.401-.311 10.235 14.957 10.235 14.957s5.219 11.69 5.793 13.283c.574 1.593 0 4.204.23 5.116.23.912 2.67 1.695 3.014 2.95.345 1.254.12 3.753.35 4.199.23.445 1.16 4.998.771 6.134z'
        opacity={0.1}
      />

      <path
        fill='currentColor'
        d='M478.91 245.035c-.37 1.138-.943 7.732-.943 7.732-.339 4.833-3.412 6.98-5.976 7.899a12.377 12.377 0 0 1-3.591.725l-3.608 3.179L448.131 277s-6.209-11.636-4.524-11.7c1.685-.065 11.4-8.334 11.4-8.334 2.972-1.61 5.95-6.98 7.332-9.74a8.615 8.615 0 0 1-.18-.999c-.599-5.15-13.164-24.866-13.164-24.866s-4.858-5.794-6.75-16.528c-.053-.247-.09-.499-.137-.757a7.801 7.801 0 0 1-.096-1.01c-.227-4.128 2.74-5.632 6.257-5.986a24.777 24.777 0 0 1 5.51.172c1.817.232 3.618.59 5.387 1.074 1.504-.204 5.213 6.137 7.644 10.631a169.334 169.334 0 0 1 2.252 4.339s5.054 11.71 5.61 13.3c.556 1.59 0 4.215.222 5.123.223.907 2.586 1.702 2.92 2.958.333 1.257.116 3.759.339 4.205.222.445 1.133 5.015.757 6.153z'
      />

      <path
        fill='#000'
        d='M499 219.282c-3.245 3.284-8.485 3.295-12.692 1.607-4.207-1.688-7.77-4.71-11.67-7.061-2.53-1.533-5.213-2.786-7.706-4.367a37.677 37.677 0 0 1-1.081-.718c-2.877-2.014-5.37-4.602-8.35-6.429a13.062 13.062 0 0 0-6.705-2.143 7.686 7.686 0 0 0-3.196.665 4.343 4.343 0 0 0-.541.262 13.78 13.78 0 0 0-2.704 2.01c-.844.75-1.65 1.548-2.536 2.25-.054-.247-.092-.499-.14-.756a7.613 7.613 0 0 1-.098-1.007 21.26 21.26 0 0 1-2.033.102 19.23 19.23 0 0 1-6.441-1.072c0-.08 0-.16-.049-.24-.73-3.816-2.05-7.855-5.148-9.998-1.795-1.243-4.661-1.752-7.149-2.679-2.368-8.167.916-16.91 8.096-21.556 7.181-4.647 16.581-4.112 23.178 1.318 6.597 5.43 8.849 14.488 5.553 22.333 3.147-.407 7.64 0 13.725 2.555 14.346 6.044 17.71 6.355 17.71 6.355l7.208 9.375c-.778 1.179-1.66 2.341-1.741 3.718-.135 2.524 2.347 4.286 4.51 5.476z'
        opacity={0.1}
      />

      <path
        fill='#48423E'
        d='M427.844 189.643c3.059 2.124 4.362 6.122 5.088 9.897.224 1.178.437 2.42 1.164 3.355 1.601 2.092 4.89 1.502 7.01 0 2.119-1.503 3.79-3.78 6.155-4.842 3.139-1.412 6.833-.382 9.775 1.45 2.942 1.831 5.403 4.395 8.243 6.37 2.75 1.928 5.814 3.303 8.675 5.039 3.85 2.33 7.368 5.34 11.521 6.997 4.154 1.656 9.343 1.651 12.525-1.593-2.135-1.178-4.586-2.92-4.42-5.447.165-2.527 3.123-4.412 2.925-7.002-.197-2.591-3.262-3.605-5.461-4.88-4.592-2.654-6.551-8.494-7.533-13.883-.764-4.215-1.394-8.924-4.56-11.632-2.044-1.741-4.804-2.31-6.865-4.035-1.949-1.64-3.033-4.12-4.271-6.408-2.045-3.807-4.73-7.348-8.28-9.625-3.55-2.278-8.067-3.186-11.965-1.625-1.494.59-2.856 1.503-4.33 2.124-3.672 1.593-7.874 1.364-11.51 3.026-4.479 2.05-7.388 6.573-10.052 10.868-2.253 3.679-6.722 10.167-5.456 14.945 1.26 4.857 8.301 4.597 11.622 6.901z'
      />

      <path
        fill='#000'
        d='M496.44 203.508a3.49 3.49 0 0 0-.101-.598c-.81 1.298-1.816 2.559-1.912 4.08-.02.351.008.704.085 1.048.9-1.461 2.056-2.836 1.928-4.53zm-10.096 10.701c-4.142-1.695-7.646-4.775-11.485-7.16-2.86-1.776-5.916-3.183-8.658-5.155-2.833-2.042-5.287-4.666-8.221-6.518-2.934-1.853-6.614-2.928-9.75-1.489-2.359 1.087-4.02 3.395-6.14 4.96-2.118 1.564-5.366 2.173-6.99 0-.725-.956-.938-2.227-1.161-3.433-.719-3.862-2.024-7.953-5.07-10.126-3.317-2.363-10.34-2.096-11.612-7.061a7.865 7.865 0 0 1-.165-2.716c-.815 2.216-1.236 4.443-.74 6.382 1.277 4.987 8.3 4.72 11.613 7.062 3.05 2.173 4.35 6.269 5.074 10.13.224 1.207.437 2.478 1.155 3.434 1.598 2.14 4.878 1.537 6.997-.027 2.12-1.565 3.775-3.868 6.14-4.954 3.13-1.44 6.815-.386 9.749 1.488s5.388 4.498 8.221 6.519c2.742 1.977 5.799 3.378 8.653 5.155 3.839 2.39 7.348 5.47 11.49 7.165 4.143 1.695 9.319 1.684 12.492-1.63-.82-.45-1.6-.975-2.327-1.57-2.886 1.081-6.33.744-9.265-.456z'
        opacity={0.1}
      />

      <path
        fill='currentColor'
        d='m392.368 251.33 43.1-16.07a4.1 4.1 0 0 1 3.135.108 4.086 4.086 0 0 1 2.027 5.422 4.097 4.097 0 0 1-2.297 2.134L395.234 259l-9.234-.925 6.368-6.744z'
      />

      <path
        fill='#FFF'
        d='M439.443 236.725c.792 2.084-.286 4.404-2.408 5.184l-43.1 15.806-6.938-.683-.997 1.058 9.234.91 43.1-15.811a4.071 4.071 0 0 0 2.296-2.1 3.958 3.958 0 0 0 .111-3.079 4.026 4.026 0 0 0-1.675-2.01c.148.23.274.472.377.725z'
        opacity={0.1}
      />

      <path
        fill='#EFC8C4'
        d='m391.203 251 2.797 8-7.384-.791-1.616-.174 2.21-2.502z'
      />

      <path
        fill='#727A9C'
        d='M387.41 255c.19.152.352.345.473.566a.874.874 0 0 1 0 .874c-.133.14-.285.257-.45.346-.379.272-.622.72-.657 1.214l-1.776-.195 2.41-2.805z'
      />

      <path
        fill='#87C104'
        d='m354.61 168.913-7.127-3.455a.858.858 0 0 1-.396-1.145l.756-1.544a.854.854 0 0 1 1.151-.393l4.802 2.326 5.014-10.219a.869.869 0 0 1 1.152-.399l1.553.756a.852.852 0 0 1 .396 1.145l-6.15 12.534a.86.86 0 0 1-1.151.394zm15.004 45.012-7.13-3.456a.85.85 0 0 1-.396-1.145l.755-1.543a.87.87 0 0 1 1.158-.394l4.8 2.326 5.01-10.23a.87.87 0 0 1 1.152-.399l1.549.756a.85.85 0 0 1 .402 1.145l-6.153 12.536a.875.875 0 0 1-1.157.393l.01.011zm-7.001-24.012-7.127-3.452a.858.858 0 0 1-.401-1.144l.76-1.542a.861.861 0 0 1 1.152-.393l4.802 2.324 5.014-10.226a.867.867 0 0 1 1.152-.393l1.553.75a.863.863 0 0 1 .396 1.149l-6.155 12.534a.867.867 0 0 1-1.152.393h.006zm13.997 44.001-7.127-3.455a.858.858 0 0 1-.396-1.145l.756-1.544a.86.86 0 0 1 1.151-.394l4.802 2.327 5.014-10.22a.874.874 0 0 1 1.157-.398l1.548.756a.852.852 0 0 1 .396 1.145l-6.144 12.535a.874.874 0 0 1-1.157.393zM105.273 372s3.005 4.169-1.384 10.46c-4.388 6.291-8.014 11.607-6.565 15.54 0 0 6.626-11.687 12.014-11.848 5.389-.16 1.864-7.121-4.065-14.152z'
      />

      <path
        fill='#000'
        d='M105.184 372c.266.402.476.842.623 1.306 5.318 6.55 8.174 12.66 3.04 12.842-4.766.139-10.483 9.064-11.847 11.317.041.182.094.36.158.535 0 0 6.703-11.67 12.154-11.83 5.45-.161 1.87-7.15-4.128-14.17z'
        opacity={0.1}
      />

      <path
        fill='#FFD037'
        d='M112 378.045c0 1.613-.226 2.955-.504 2.955-.277 0-.496-1.312-.496-2.955s.277-.857.555-.857c.277 0 .445-.762.445.857zm2.056 2.481c-1.563 1.045-2.93 1.683-3.048 1.412-.117-.272 1.055-1.324 2.605-2.393 1.55-1.068.944-.287 1.061 0 .118.287.951-.063-.618.981z'
      />

      <path
        fill='#87C104'
        d='M87.725 372s-3 4.169 1.388 10.46c4.388 6.291 8.009 11.607 6.564 15.54 0 0-6.62-11.687-12.012-11.848-5.393-.16-1.868-7.121 4.06-14.152z'
      />

      <path
        fill='#000'
        d='M87.821 372c-.262.403-.47.842-.617 1.306-5.316 6.55-8.163 12.66-3.036 12.842 4.755.139 10.465 9.064 11.832 11.317-.043.182-.097.36-.163.535 0 0-6.69-11.718-12.148-11.879-5.46-.16-1.857-7.1 4.132-14.121z'
        opacity={0.1}
      />

      <path
        fill='#FFD037'
        d='M83 378.045c0 1.613.219 2.955.496 2.955.278 0 .504-1.312.504-2.955s-.277-.857-.555-.857c-.277 0-.445-.762-.445.857zm-2.055 2.481c1.569 1.045 2.93 1.683 3.047 1.412.117-.272-1.055-1.324-2.605-2.393-1.55-1.068-.95-.287-1.068 0-.117.287-.937-.063.626.981z'
      />

      <ellipse
        cx={96.5}
        cy={425}
        fill='currentColor'
        opacity={0.1}
        rx={33.5}
        ry={5}
      />

      <path
        fill='#65617D'
        d='m114.992 391.978-.164 1.32-.224 1.863-.098.777-.224 1.864-.104.777-.224 1.863-2.6 21.19c-.235 1.89-3.344 3.368-7.102 3.368h-13.5c-3.753 0-6.856-1.478-7.101-3.369l-2.6-21.189-.23-1.863-.093-.777-.235-1.864-.093-.777-.23-1.863-.163-1.32C79.88 390.89 81.558 390 83.683 390h27.638c2.13 0 3.808.907 3.671 1.978z'
      />

      <path
        fill='#9D9CB5'
        d='m114 394-.225 1H80.22l-.22-1zm0 3-.23 1H80.23l-.23-1zm-1 2-.22 1H81.22l-.22-1z'
      />
    </g>
  </svg>
)

export default IllustrationClaims
